export default "__VITE_ASSET__BY6u6spd__"